/* 작품 관리 - 
작품 api & 에피소드 api */

import { COMMON, ifyouApi, STORY } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

//***** 작품
export const totalProjectList = async (lang, userId, masterAuth) => {
  try {
    const response = await ifyouApi.post(``, {
      lang: lang,
      user_id: userId,
      master_auth: masterAuth,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(
        error.response.status,
        error.response.data,
        error.response.koMessage,
      );
    }
  }
};

/// *****  작품 상세(에피소드 영역)
export const projectDetail = async (projectId, lang) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}`, { lang: lang });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

/// 선택한 작품 상세 정보 - 수정용 조회
export const projectDetailView = async (projectId, lang) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/story-detail`, {
      lang: lang,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
//* 프로젝트 api promise */
export const projectApis = {
  register: (title) =>
    ifyouApi
      .post(`${STORY}/register-story`, { title: title })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (
    projectId,
    detailData,
    newObject,
    newHash,
    missionData,
    localizingData,
  ) =>
    ifyouApi
      .post(`${STORY}/${projectId}/update-story`, {
        bubble_set_id: detailData.bubble_set_id,
        favor_use: detailData.favor_use,
        is_complete: detailData.is_complete,
        is_credit: detailData.is_credit,
        is_public: detailData.is_public,
        is_lock: detailData.is_lock,
        genre: detailData.genre,
        color_rgb: detailData.color_rgb,
        is_deploy: detailData.is_deploy,
        serial_day: detailData.serial_day?.toString(),
        essential_tag: detailData.essential_tag,
        exception_culture: detailData.exception_culture,
        main_sound_id: detailData.main_sound_id,
        ifyou_thumbnail_id: newObject.ifyou_thumbnail_id,
        episode_finish_id: newObject.episode_finish_id,
        premium_pass_id: newObject.premium_pass_id,
        coin_banner_id: newObject.coin_banner_id,
        langList: localizingData,
        tagList: newHash,
        // tagList: [{ hashtag_no: 0 }],
        missionList: missionData,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

export const projectHashtagDelete = async (projectId, hashtagNo) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/delete-hashtag`, {
      hashtag_no: hashtagNo,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const missionDelete = async (projectId, sortKey) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/mission-delete`, {
      sortkey: sortKey,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

// * 프로젝트 수정 - 장르 리스트
export const fetchGenreList = async () => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'standard',
      code: 'genre',
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
// 옵션 태그 리스트
export const fetchHashTagList = async () => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'getHashtagDropdown',
      search_word: '',
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
// 말풍선 세트 리스트
export const fetchBubbleSetList = async () => {
  try {
    const res = await ifyouApi.post();
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
// 미션 보상 종류 - 재화 목록
export const fetchCurrencyList = async (searchWord) => {
  try {
    const response = await ifyouApi.post(`${COMMON}`, {
      func: 'getCurrencyList',
      word: searchWord,
    });
    let newData = [];
    response.data.map((v, i) =>
      newData.push({ key: i, text: v.origin_name, value: v.currency }),
    );
    return newData;
  } catch (error) {
    if (error.response) {
      ErrorMessage(
        error.response.status,
        error.response.data,
        error.response.koMessage,
      );
    }
  }
};

// ***** 에피소드 영역
export const episodeList = async (lang, projectId) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/episode-list-new`, {
      lang: lang,
    });
    let newData = [];
    res.data?.map((v) =>
      newData.push({
        ...v,
        episode_type_ko:
          v.episode_type === 'chapter'
            ? '에피소드'
            : v.episode_type === 'side'
            ? '사이드'
            : v.episode_type === 'ending' && '엔딩',
      }),
    );
    return newData;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const episodeRegister = async (lang, projectId, inputDatas) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/episode-insert-new`,
      {
        title: inputDatas.title,
        episode_type: inputDatas.episode_type,
        lang: lang,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const episodeUpdate = async (
  projectId,
  episodeId,
  record,
  langList,
  publishDate,
) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/episode-update`, {
      episode_id: episodeId,
      episode_type: record.episode_type,
      price: record.price,
      ending_type: record.ending_type,
      episode_status: record.episode_status,
      depend_episode: record.depend_episode,
      unlock_style: record.unlock_style,
      unlock_episodes: record.unlock_episodes,
      unlock_scenes: record.unlock_scenes,
      unlock_coupon: record.unlock_coupon,
      sale_price: record.sale_price,
      square_image_id: record.square_image_id,
      popup_image_id: record.popup_image_id,
      currency: record.currency,
      one_currency: record.one_currency,
      one_price: record.one_price,
      first_reward_currency: record.first_reward_currency,
      first_reward_quantity: record.first_reward_quantity,
      first_reward_exp: record.first_reward_exp,
      publish_date: publishDate,
      next_open_min: Number(record.next_open_min),
      open_decrease_rate: Number(record.open_decrease_rate),
      langList: langList,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const episodeDelete = async (projectId, episodeId) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/episode-delete`, {
      episode_id: episodeId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const episodeDetail = async (projectId, episodeId) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/episode-detail`, {
      episode_id: episodeId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const episodeSorting = async (projectId, rows) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/episode-sorting`, {
      rows: rows,
    });
    return res;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchEpisodeSquareThumbList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/com-design-select`, {
      design_type: 'episode_square',
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const fetchEpisodePopupThumbList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${STORY}/${projectId}/com-design-select`, {
      design_type: 'episode_big',
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const fetchEpisodeUnlockList = async () => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'standard',
      code: 'unlock_style',
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

//잠금해제 에피소드 리스트
export const fetchUnlockEpisodeTargetList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'targetProjectEpisodeUnlock',
      project_id: `${projectId}`,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

//잠금해제 사건 리스트
export const fetchUnlockSceneList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'targetProjectSceneUnlock',
      project_id: `${projectId}`,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const fetchUnlockCouponList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'targetCouponUnlock',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

//* episode 선택지 확정
export const episodeSelectionConfirm = async (lang, projectId, rows) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/episode-selection-all`,
      {
        rows: rows,
        lang: lang,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

//* 스크립트 데이터
export const scriptData = async (projectId, episodeId, lang) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/contents/${episodeId}/object`,
      {
        lang: lang,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

export const scriptDataSubmit = async (projectId, episodeId, lang, rows) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/contents/${episodeId}/update-object`,
      {
        lang: lang,
        rows: rows,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const scriptConfirm = async (projectId, episodeId, lang, rows) => {
  try {
    const res = await ifyouApi.post(
      `${STORY}/${projectId}/contents/${episodeId}/update-confirm`,
      {
        lang: lang,
        rows: rows,
      },
    );
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

/** 프로젝트 수정 - 이미지 드롭다운 데이터 리스트 */
export const fetchCategoryList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'projectImageList',
      code: 'category_thumbnail',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchIfyouBannerList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'projectImageList',
      code: 'ifyou_banner',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchReadyList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'projectImageList',
      code: 'ifyou_thumbnail',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchEndingList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'projectImageList',
      code: 'episode_finish',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchPremiumList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'projectImageList',
      code: 'premium_pass',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchCoinBannerList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'projectImageList',
      code: 'coin_banner',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchCircleList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'projectImageList',
      code: 'ifyou_circle',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchIntroduceList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'projectImageList',
      code: 'introduce_image',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

/** 에피소드 - 스크립트에서 쓰이는 드롭다운 데이터 목록 */
export const fetchTemplateList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'standard',
      code: 'script_template',
      expression: '',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchCharacterList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'project_character_expression',
      code: '',
      expression: '',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchEmoticonList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'project_emoticon_expression',
      code: '',
      expression: '',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchInEffectList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'standard_array',
      code: 'in_effect',
      expression: '',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
export const fetchOutEffectList = async (projectId) => {
  try {
    const res = await ifyouApi.post(`${COMMON}`, {
      func: 'standard_array',
      code: 'out_effect',
      expression: '',
      project_id: projectId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
